import React from 'react';

import FormatHelpers from '../helpers/FormatHelpers';
import { classeMarcador, nivelProbabilidade } from '../rules/regraContexto';

const TabelaPacientes = ({ pacientes, theme, locationName }) => (
  <table className={'table table-striped' + (theme === 'dark' ? '-dark' : '')}>
    <thead>
      <tr>
        <th></th>
        <th>Atendimento</th>
        <th>Paciente</th>
        <th>Setor</th>
        <th>Especialidade</th>
        <th>Entrada</th>
        <th>Probabilidade</th>
        <th>Contexto (até 72h)</th>
      </tr>
    </thead>
    <tbody className={theme}>
      {pacientes.map((data) => {
        const nivel = nivelProbabilidade(data.previsaointernacao);

        return (
          <tr key={'tr-' + data.codigoatendimento} className={classeMarcador(data)}>
            <td className="alert-content"><div className="alert-label" /></td>
            <td align="left" className="colunaAtendimento">{data.codigoatendimento}</td>
            <td align="left">
              <span className="pacienteNome">{FormatHelpers.formatarNomePaciente(data.nomepaciente, locationName)}</span>
              <span className="pacienteNascimento">{FormatHelpers.formatarNascimento(data.nascimentopaciente)}</span>
            </td>
            <td align="left">{FormatHelpers.formatarDescricao(data.descricaosetor)}</td>
            <td align="left">{FormatHelpers.formatarDescricao(data.descricaoespecialidade)}</td>
            <td align="left">{FormatHelpers.formatarTempoEntrada(data.valor)}</td>
            <td align="left">
              <div className="probabilidade">
                <span className={'probabilidade-valor nivel-' + nivel}>{data.previsaointernacao}%</span>
                <span className="probabilidade-trilho">
                  <span className={'probabilidade-preenchimento nivel-' + nivel} style={{ width: FormatHelpers.larguraProbabilidade(data.previsaointernacao) }} />
                </span>
              </div>
            </td>
            <td align="left">
              {data.contexto && (
                <span className={'badgeContexto horas-' + FormatHelpers.faixaContexto(data.contexto)}>
                  {FormatHelpers.formatarContexto(data.contexto)}
                </span>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default TabelaPacientes;
